import { Tooltip, IconButton, Typography, Box, Grid } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const PermissionRuleTooltip = () => {
    return (
        <Tooltip
            arrow
            placement="top"
            componentsProps={{
                tooltip: {
                    sx: {
                        fontSize: '0.95rem',
                        maxWidth: 500,
                        backgroundColor: 'rgba(40, 40, 40, 0.85)',
                        color: '#fff',
                        backdropFilter: 'blur(6px)',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        px: 2,
                        py: 1.5,
                    },
                },
                arrow: {
                    sx: {
                        color: 'rgba(40, 40, 40, 0.85)',
                    },
                },
            }}
            title={
                <Box sx={{ direction: 'ltr' }}>
                    <Typography variant="body2" gutterBottom>
                        חוק הוא מחרוזת בצורה:
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 'bold',
                            fontFamily: 'monospace',
                            mb: 2,
                        }}
                    >
                        collection.field.action
                    </Typography>

                    <Typography variant="body2" gutterBottom>
                        לדוגמא:
                    </Typography>

                    <Grid container rowSpacing={1} columnSpacing={2}>
                        <Grid item xs={5}>
                            <Typography
                                variant="body2"
                                dir="ltr"
                                sx={{
                                    fontFamily: 'monospace',
                                    fontWeight: 'bold',
                                }}
                            >
                                users.email.read
                            </Typography>
                        </Grid>
                        <Grid item xs={7}>
                            <Typography variant="body2" dir="rtl">
                                נותן גישה לקריאת שדה אימייל של יוזרים.
                            </Typography>
                        </Grid>

                        <Grid item xs={5}>
                            <Typography
                                variant="body2"
                                dir="ltr"
                                sx={{
                                    fontFamily: 'monospace',
                                    fontWeight: 'bold',
                                }}
                            >
                                users.*.*
                            </Typography>
                        </Grid>
                        <Grid item xs={7}>
                            <Typography variant="body2" dir="rtl">
                                נותן גישה לכל השדות ולכל הפעולות של יוזרים.
                            </Typography>
                        </Grid>

                        <Grid item xs={5}>
                            <Typography
                                variant="body2"
                                dir="ltr"
                                sx={{
                                    fontFamily: 'monospace',
                                    fontWeight: 'bold',
                                }}
                            >
                                *.*.*
                            </Typography>
                        </Grid>
                        <Grid item xs={7}>
                            <Typography variant="body2" dir="rtl">
                                נותן גישה להכל.
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            }
        >
            <IconButton size="small">
                <InfoOutlined fontSize="small" />
            </IconButton>
        </Tooltip>
    );
};

export default PermissionRuleTooltip;
